/**
 * Fixes the labels for input fields that are in focus in the given @inputContainers.
 * Triggers label transition and prevents label from overlapping the field.
 * @param {Object} inputContainers
 */
function fixFocusedInLabels(inputContainers) {
    inputContainers.find("label").addClass("disable-animations");
    inputContainers.addClass("input-has-focus");
    // read out css to trigger a reflow and flush the css changes
    // see https://stackoverflow.com/questions/11131875/what-is-the-cleanest-way-to-disable-css-transition-effects-temporarily
    inputContainers.find("label").css("background-color");
    inputContainers.find("label").removeClass("disable-animations");
}

/**
 * Fixes the labels for input fields that are already filled in the given @inputContainerClass.
 * Triggers label transition and prevents label from overlapping the field.
 * If attemptNr === 100 returns.
 * @param {String} inputContainerClass
 * @param {Number} attemptNr
 */
function fixAutofilledInputLabels(inputContainerClass, attemptNr = 0) {
    if (attemptNr === 100) return;

    let inputContainers = $(inputContainerClass + " input:-webkit-autofill").closest(inputContainerClass);
    if (inputContainers.length > 0) {
        fixFocusedInLabels(inputContainers);
    } else {
        setTimeout(function () {
            fixAutofilledInputLabels(inputContainerClass, attemptNr + 1);
        }, 10);
    }
}

/**
 * Fixes the labels for input fields that are already filled or in focus.
 * Triggers label transition and prevents label from overlapping the field.
 */
export default function initFixLabels() {
    fixFocusedInLabels(
        $(".styled-input input").filter(function (index, element) {
            return element.value
        }).closest(".styled-input"));
    fixFocusedInLabels(
        $(".form-group input").filter(function (index, element) {
            return element.value
        }).closest(".form-group"));
    fixAutofilledInputLabels(".styled-input");
    fixAutofilledInputLabels(".form-group");
}